import { AloBioLg, getDefaultAloBioLg } from "./AloBioLg"
import { AloBase, getDefaultAloBase } from "./AloBase"


export interface AloBio extends AloBase  {         
    image?:string, 
    lgs:Array<AloBioLg>
}

export const getDefaultAloBio = ():AloBio => {
    return {
        ...getDefaultAloBase(),
        lgs:[getDefaultAloBioLg()]
    }
}